import { AbstractAggregatorService } from '@abstract-services/aggregator/1.0/aggregator.abstract-service';
import * as ngCommonHttp from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AggregatorAPI } from '@constants/api';
import { Aggregator, AggregatorsResponse } from '@interfaces/aggregator/1.0';
import { Observable, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { AggregatorsService as GeneratedAggregatorsService } from '@generated/tcea/services/aggregators.service';
import { AggregatorStoreStatusGet$Params } from '@generated/tcea/fn/aggregators/aggregator-store-status-get';
import { StoreAggregatorStatusResponse } from '@generated/tcea/models';

@Injectable({
  providedIn: 'root',
})
export class AggregatorService extends AbstractAggregatorService {
  getApiUrl: string;
  private aggregators$: Observable<Aggregator[]> | undefined;

  constructor(
    private http: ngCommonHttp.HttpClient,
    private generatedAggregatorsService: GeneratedAggregatorsService,
  ) {
    super();
    this.getApiUrl = AggregatorAPI.GET;
  }

  /**
   * Returns all Aggregators as an Observable. Caches the result for the next call.
   */
  getAggregators(): Observable<Aggregator[]> {
    if (!this.aggregators$) {
      this.aggregators$ = this.http.get(this.getApiUrl).pipe(
        map((data: AggregatorsResponse) => {
          if (data && data._embedded) {
            return data._embedded.aggregator;
          } else {
            return undefined;
          }
        }),
        catchError((err: ngCommonHttp.HttpErrorResponse) => {
          this.aggregators$ = undefined;
          return throwError(err);
        }),
        shareReplay({ bufferSize: 1, refCount: false }),
      );
    }

    return this.aggregators$;
  }

  /**
   * Gets store aggregator status on refresh
   *
   */
  getAggregatorStoreStatus(
    ActiveTenantIdentifier: string,
    storeId: string,
    aggregatorId: 'ubereats' | 'doordash',
  ): Observable<StoreAggregatorStatusResponse> {
    let params: AggregatorStoreStatusGet$Params = {
      storeId,
      'Active-Tenant-Identifier': ActiveTenantIdentifier,
      aggregatorId,
    };
    return this.generatedAggregatorsService.aggregatorStoreStatusGet(params).pipe(
      map((response: any) => {
        if (response) {
          return response;
        } else {
          return undefined;
        }
      }),
      catchError((err: ngCommonHttp.HttpErrorResponse) => throwError(err)),
    );
  }
}
